<template>
  <div class="speltcontls">
    <div class="list">
      <div v-if="currentPage == lawonlist.length" v-html="gett1" />
      <div
        class="item flex_start"
        v-for="(item, index) in lawonlist"
        :key="index"
        @click="tojump(item)"
      >
        <div class="cove">
          <img :src="item.preview_pic" />
        </div>
        <div class="ritxt">
          <div class="ritxt1 ellipsis">{{ item.title }}</div>
          <div class="ritxt2">
            {{ item.content | toEllipsisFilter(100) }}
          </div>
          <div class="ritxt3">
            <span>{{ item.issue_date }}</span>
            <span>{{ item.view_num }}次浏览</span>
          </div>
        </div>
      </div>
    </div>
    <div class="pagination mt20" v-if="lawonlist.length != 0">
      <el-pagination
        background
        layout="prev, pager, next"
        :page-count="pageCount"
        :current-page="currentPage"
        :pager-count="5"
        @current-change="turnpage"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    currentPage: 1, //当前
    pageCount: 17, //总页数
    total: 17, //总条目
    lawonlist: [],
  }),
  computed: {
    getfljjid() {
      return this.$store.state.laws.fljjxx.id;
    },
    gett1() {
      return decodeURIComponent(
        this.$store.state.user.lognavtxt +
          this.$store.state.laws.lawurl +
          this.$store.state.jpcol.jpclurl
      );
    },
  },
  beforeMount() {
    this.getlawon();
  },
  methods: {
    turnpage(e) {
      this.currentPage = e;
      this.getlawon();
    },
    tojump(current) {
      this.$router.push({
        path: "/laws/specialdet",
        query: {
          lawonId: current.id,
        },
      });
    },
    getlawon() {
      let data = {
        limit: 6,
        cat_id: this.getfljjid,
        order: "new",
        page: this.currentPage,
      };
      this.$http.laws.getnewslist(data).then((res) => {
        this.total = res.data.total;
        this.pageCount = res.data.last_page;
        this.lawonlist = res.data.data;
      });
    },
  },
  watch: {
    getfljjid() {
      this.currentPage = 1;
      this.getlawon();
    },
  },
};
</script>

<style lang="scss" scoped>
.speltcontls {
  width: 100%;
  background: #ffffff;
  padding-bottom: 50px;
  .list {
    .item {
      padding: 30px;
      align-items: flex-start;
      position: relative;
      border-bottom: 1px solid #eeee;
      cursor: pointer;
      &:hover {
        .ritxt .ritxt1 {
          color: #0465ea;
        }
      }
      .cove {
        margin-right: 20px;
        img {
          width: 248px;
          height: 148px;
        }
      }
      .ritxt {
        color: #333333;
        .ritxt1 {
          width: 525px;
          font-size: 20px;
          margin-top: 10px;
        }
        .ritxt2 {
          font-size: 14px;
          margin-top: 12px;
        }
        .ritxt3 {
          position: absolute;
          bottom: 40px;
          left: 300px;
          font-size: 12px;
          color: #333333;
          span {
            margin-right: 10px;
          }
        }
      }
      &:last-child {
        border-bottom: none;
      }
    }
  }
  .pagination {
    text-align: center;
    ::v-deep .el-pagination.is-background .btn-next,
    ::v-deep .el-pagination.is-background .btn-prev,
    ::v-deep .el-pagination button,
    ::v-deep .el-pagination span:not([class*="suffix"]),
    ::v-deep .el-pagination.is-background .el-pager li {
      min-width: 36px;
      height: 36px;
      line-height: 36px;
    }
    ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active,
    ::v-deep .el-pagination.is-background .el-pager li:not(.disabled):hover {
      color: #ffffff !important;
      background: #0057ff !important;
    }
  }
}
</style>